export const toISODate = (str) => {
  return str.split("/").reverse().join("-")
}
